import { RootState } from 'store/store.types';
import { InternalContext } from 'gql/autogen/InternalContext';
import { ReviewRequest } from 'gql/autogen/ReviewRequest';
import { DefaultRequestProps } from 'store/api/ApiConstants';
import { ActivityGqlOperation, GqlLogTags, ReviewRequestProps } from 'store/api/api.types';
import { getGeoLogTags } from 'core/service/measurements/measurementUtils';

export const buildReviewRequestProps = (props: ReviewRequestProps): Required<ReviewRequestProps> => {
    if (!props) {
        return DefaultRequestProps.review;
    }

    return {
        activityId: props.activityId,
        pagination: {
            number: props.pagination?.number || DefaultRequestProps.review.pagination.number,
            size: props.pagination?.size || DefaultRequestProps.review.pagination.size,
        },
        sort: {
            code: props.sort?.code || DefaultRequestProps.review.sort.code,
            order: props.sort?.order || DefaultRequestProps.review.sort.order,
        },
        filters: props.filters || DefaultRequestProps.review.filters,
    };
};

const build = (state: RootState, props: Required<ReviewRequestProps>, context: InternalContext): ReviewRequest => {
    return {
        context,
        reviewRequest: {
            searchCriteria: {
                activityId: props.activityId,
                pagination: {
                    number: props.pagination.number,
                    size: props.pagination.size,
                },
                sort: {
                    code: props?.sort?.code,
                    order: props?.sort?.order,
                },
                filters: props?.filters,
            },
        },
    };
};

export const buildLogTags = (state: RootState, variables: Record<string, unknown>): GqlLogTags => {
    const request = (variables as unknown as { ReviewRequest: ReviewRequest }).ReviewRequest.reviewRequest;
    const searchCriteria = request.searchCriteria;
    const geoTags = getGeoLogTags(state.bootstrap.config);
    return {
        ...geoTags,
        operation: ActivityGqlOperation.review,
        activityId: searchCriteria.activityId.toString(),
        pageSize: String(searchCriteria.pagination.size),
        pageNumber: String(searchCriteria.pagination.number),
        sortCode: String(searchCriteria.sort.code),
        sortOrder: String(searchCriteria.sort.order),
    };
};

export default build;
